module.exports = __webpack_public_path__ + "img/metavesco.57786f64.png";